{
  "title": "Profil de l'entreprise",
  "subtitle": "Qui vous êtes et comment les nombres et les dates s'affichent dans l'application. Seuls les administrateurs peuvent le modifier.",
  "subtitleReadOnly": "Qui vous êtes et comment les nombres et les dates s'affichent dans l'application. Vous pouvez le consulter ; seuls les administrateurs peuvent le modifier.",
  "lastChanged": "Modifié le {{date}} par {{name}}",
  "seeHistory": "voir l'historique",
  "saved": "Profil de l'entreprise enregistré",
  "identity": {
    "title": "Identité"
  },
  "contact": {
    "title": "Coordonnées",
    "bankHint": "Imprimé au pied des factures et des bons de livraison."
  },
  "regional": {
    "title": "Paramètres régionaux",
    "currencyHint": "Fixe dans cette version.",
    "currencyValue": "{{code}} · {{decimals}} décimales"
  },
  "fields": {
    "legalName": "Raison sociale",
    "tradeName": "Nom commercial",
    "taxId": "Matricule fiscal",
    "tradeRegisterNo": "N° du registre de commerce",
    "address": "Adresse",
    "city": "Ville",
    "phone": "Téléphone",
    "email": "Email",
    "website": "Site web",
    "currency": "Devise",
    "defaultLanguage": "Langue par défaut",
    "timezone": "Fuseau horaire",
    "dateFormat": "Format des dates",
    "numberFormat": "Format des nombres",
    "fiscalYearStartMonth": "Début de l'exercice",
    "bankName": "Banque",
    "rib": "RIB"
  },
  "logo": {
    "alt": "Logo de l'entreprise",
    "upload": "Importer un logo",
    "replace": "Remplacer le logo",
    "remove": "Retirer",
    "hint": "PNG, JPEG, WebP ou SVG, 1 Mo maximum. Un format carré rend mieux.",
    "tooLarge": "Ce fichier dépasse 1 Mo.",
    "saved": "Logo mis à jour",
    "removed": "Logo retiré"
  },
  "preview": {
    "title": "Aperçu",
    "subtitle": "Voici comment les valeurs s'afficheront pour les utilisateurs qui gardent la langue par défaut :",
    "stockValue": "Valeur du stock",
    "dateTime": "Date et heure",
    "quantityKg": "Quantité en kg"
  },
  "saveBar": {
    "note": "Chaque modification est enregistrée dans le journal d'activité avec l'ancienne et la nouvelle valeur.",
    "undo": "Annuler les changements"
  },
  "history": {
    "title": "Historique du profil",
    "subtitle": "Chaque modification, avec l'ancienne et la nouvelle valeur.",
    "empty": "Aucune modification enregistrée pour l'instant."
  }
}
